import { render, staticRenderFns } from "./MenuEditLogItem.vue?vue&type=template&id=89a651d4&scoped=true&"
import script from "./MenuEditLogItem.vue?vue&type=script&lang=js&"
export * from "./MenuEditLogItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuEditLogItem.vue?vue&type=style&index=0&id=89a651d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a651d4",
  null
  
)

export default component.exports